// extracted by css-extract-rspack-plugin
export default {"cls1":"StickySidebar-cls1_TcX","cls2":"StickySidebar-cls2_Hbf StickySidebar-cls1_TcX"};